/**
 * Resolve plan records from `plans` query results, keyed by the UI config shape.
 * LICENSE/SUPPORT match by frequency; CREATIVES matches by tier and frequency.
 */
import { SUBSCRIPTION_CREATIVE, SUBSCRIPTION_LICENSE, SUBSCRIPTION_SUPPORT } from './constants'

export const typeToConfigKey = {
    LICENSE: SUBSCRIPTION_LICENSE,
    SUPPORT: SUBSCRIPTION_SUPPORT,
    CREATIVES: SUBSCRIPTION_CREATIVE,
}

const configKeyToType = Object.fromEntries(
    Object.entries(typeToConfigKey).map(([type, key]) => [key, type])
)

export const getTypeForConfigKey = (key) => configKeyToType[key] ?? null

export const findLicensePlan = (plans, cycle) =>
    (plans ?? []).find((plan) => plan.type === 'LICENSE' && plan.frequency === cycle) ?? null

export const findSupportPlan = (plans, cycle) =>
    (plans ?? []).find((plan) => plan.type === 'SUPPORT' && plan.frequency === cycle) ?? null

export const findCreativesPlan = (plans, tier, frequency) =>
    (plans ?? []).find(
        (plan) =>
            plan.type === 'CREATIVES' && plan.tier === tier && plan.frequency === frequency
    ) ?? null

export const resolveLicensePlanId = (plans, cycle) => findLicensePlan(plans, cycle)?.id ?? null

export const resolveSupportPlanId = (plans, cycle) => findSupportPlan(plans, cycle)?.id ?? null

export const resolveCreativesPlanId = (plans, tier, frequency) =>
    findCreativesPlan(plans, tier, frequency)?.id ?? null
